var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9 .03c4.893 0 8.725 5.377 8.886 5.606.152.217.152.511 0 .728-.161.23-3.993 5.605-8.886 5.605-4.894 0-8.725-5.376-8.886-5.605-.152-.217-.152-.511 0-.729C.274 5.407 4.106.031 9 .031zm0 1.236C5.388 1.266 2.272 4.832 1.35 6c.923 1.166 4.045 4.734 7.65 4.734 3.612 0 6.728-3.566 7.65-4.734-.924-1.167-4.046-4.734-7.65-4.734zm0 1.029c1.963 0 3.56 1.662 3.56 3.705S10.963 9.705 9 9.705 5.44 8.043 5.44 6 7.036 2.295 9 2.295zM9 3.53C7.69 3.53 6.626 4.638 6.626 6S7.691 8.47 9 8.47c1.309 0 2.374-1.108 2.374-2.47S10.309 3.53 9 3.53z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicate);
export default __webpack_public_path__ + "static/media/indicate.d28827a08fb17608a418a196b8cdd524.svg";
export { ForwardRef as ReactComponent };